app.directive("stickyButton",function($mdDialog){
   
    return {
      
      restrict:"E",  
      templateUrl:"/assets/js/angular/components/directives/sticky/button.html",
      require: '^^sticky',
      scope:{
          
          aClass:"@",
          iClass:"@",
          onClick:"=",
          title:"@",
          stConfirm:"=",//true false
          stConfirmText:"@",//true false
          
      },
      link:function(scope){
        
            scope.click=function(){
              
                if (!scope.stConfirm)
                return scope.onClick();//no confirm
            
            
                //confirmation is on
                openModal();
                
            };
        
        
            function openModal() {
                    $mdDialog.show({
                            templateUrl: '/assets/js/angular/components/directives/confirmation/confirmation.html',
                            controller: modalCtrl,
                            locals: {
                                    message: scope.stConfirmText,
                                    title: "Potwierdź wykonanie akcji"
                            }
                    }).then(function(){
                        
                        scope.onClick();
                    });

            };

            function modalCtrl($scope, $mdDialog, locals) {
                    $scope.title = locals.title;
                    $scope.message = locals.message;

                    $scope.commit= function() {
                            $mdDialog.hide();
                    };

                    $scope.cancel= function() {
                            $mdDialog.cancel();
                    };

            };
          
          
      }
        
    };
    
});
